import {AfterContentChecked, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpService} from '../service/http.service';
import {TranslateService} from '@ngx-translate/core';
import {Meta} from '@angular/platform-browser';

@Component({
  selector: 'app-news-page',
  templateUrl: './news-page.component.html',
  styleUrls: ['./news-page.component.css']
})
export class NewsPageComponent implements OnInit, AfterContentChecked {
  newsElement: any;
  allNews: any;

  newsElements = [
    {
      id: 6,
      image: 'assets/imgs/turkey/2.jpeg',
      published: new Date('2024-12-30'),
      title: '2024 жылғы 20-30 желтоқсан аралығында Анкара (Турция) қаласында тоғызқұмалақтан 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті. Оған: Турция, Молдова, Румыния, Қазақстан елдерінен спортшылар қатысты. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізді. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетті.',
      description: "Нәтижесінде рапид бойынша, 13 жасқа дейінгі ұлдар:\n" +
        "1 орын KAIRIDENOV ARNAT (Қазақстан);\n" +
        "2 орын BALAGAZ ISLAM (Қазақстан);\n" +
        "3 орын MANASTIRLI NIKITA METEHAN (Молдова);\n" +
        "3 орын MANASTIRLI ALEKSANDR KAAN (Молдова).\n" +
        "13 жасқа дейінгі қыздар:\n" +
        "1 орын SADIR AMINA (Қазақстан);\n" +
        "2 орын MAKHMUT AIZERE (Қазақстан);\n" +
        "3 орын MATEI SOFIA ECATERINA (Румыния).\n" +
        "15 жасқа дейінгі ұлдар:\n" +
        "1 орын TURGYNBAY IBRAKHIM (Қазақстан);\n" +
        "2 орын MUCICA RAVZAN ANDREI (Румыния);\n" +
        "3 орын YERKIN YERNAR (Қазақстан).\n" +
        "15 жасқа дейінгі қыздар:\n" +
        "1 орын AZAT ARUZHAN(Қазақстан);\n" +
        "2 орын ASSEMKHANOVA MALIKA (Қазақстан);\n" +
        "3 орын YILMAZ ZEINEP (Тұркия).\n" +
        "17 дейінгі ұлдар:\n" +
        "1 орын YESSENTAY ARSEN (Қазақстан);\n" +
        "2 орын AZYRALY AZIZ (Қазақстан);\n" +
        "3 орын SAPAR TAMERLAN (Қазақстан).\n" +
        "17 жасқа дейінгі қыздар:\n" +
        "1 орын ISSAKHAN AYANA (Қазақстан);\n" +
        "2 орын TILEGENOVA BALNUR (Қазақстан);\n" +
        "3 орын DAULETBEK TOMIRIS (Қазақстан).\n" +
        "Классика бойынша,\n" +
        "Ұлдар арасында:\n" +
        "1 орын SAPAR TAMERLAN (Қазақстан);\n" +
        "2 орын TURGYNBAY IBRAKHIM (Қазақстан);\n" +
        "3 орын YESSENTAY ARSEN (Қазақстан).\n" +
        "Қыздар арасында:\n" +
        "1 орын ISSAKHAN AYANA (Қазақстан);\n" +
        "2 орын DAULETBEK TOMIRIS (Қазақстан);\n" +
        "3 орын ASSEMKHANOVA MALIKA (Қазақстан).\n"
    },
    {
      id: 8,
      image: 'assets/imgs/turkey/1.jpeg',
      published: new Date('2024-12-30'),
      title: '2024 жылғы 20-30 желтоқсан аралығында Түркияның Анкара қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа 13, 15, 17 жасқа дейінгі Түркия, Молдова, Румыния, Қазақстан елдерінің спортшылары қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы және Мангала Федерациясы бірігіп өткізуде. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде.',
      description: ''
    },
    {
      id: 7,
      image: 'assets/imgs/czhecia/1.jpeg',
      published: new Date('2024-12-16'),
      title: '2024 жылғы 6-16 желтоқсан аралығында Чехияның Прага қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа 13, 15, 17 жасқа дейінгі Чехия, Испания, Венгрия, Польша, Қазақстан елдерінің спортшылары қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізуде. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде.',
      description: ' '
    },
    {
      id: 10,
      image: 'assets/imgs/kyrgyzstan/2.jpeg',
      published: new Date('2024-12-12'),
      title: '2024 жылғы 5-12 желтоқсан аралығында Қырғызстанның Бішкек қаласында тоғызқұмалақтан халықаралық турнир өтті. Жарысқа Қырғызстан, Өзбекстан, Ресей, Қазақстан елдерінен 235 спортшы қатысты. Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory  демеушілік қолдау көрсетті.',
      description: "Нәтижесінде, ерлер арасында:\n" +
        "1. Агитаев Салахадин (Қазақстан, Павлодар облысы).\n" +
        "2. Батыр Ернұр (Қазақстан, Алматы облысы).\n" +
        "3. Манарбекұлы Арыстан (Қазақстан, Астана қаласы).\n" +
        "4. Джамакеев Анарбек (Қырғызстан, Бішкек қаласы).\n" +
        "Әйелдер арасында:\n" +
        "1. Махамбетамин Ұлдана (Қазақстан, Қызылорда облысы).\n" +
        "2. Сапарбекова Салтанат (Қазақстан, Шымкент қаласы).\n" +
        "3. Кенжебекова Әкерке (Қазақстан, Қызылорда облысы).\n" +
        "4. Манарбекқызы Ақжібек (Қазақстан, Астана қаласы).\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "2024 жылғы 5-12 желтоқсан аралығында Қырғызстан Республикасының Бішкек қаласында тоғызқұмалақтан Ч.Айтматовты еске алуға арналған халықаралық турнир өтуде. Жарысқа Қазақстан, Қырғызстан, Өзбекстан және Ресей елдерінен 235 спортшы қатысуда. Жарыс ардагерлер, ерлер мен әйелдер, U-15 ұлдар мен қыздар арасында өтуде.\n" +
        "Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына Қазақстан Республикасының Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде.\n"
    },
    {
      id: 11,
      image: 'assets/imgs/columbia/2.jpeg',
      published: new Date('2024-11-30'),
      title: '2024 жылғы 22-30 қараша аралығында Колумбияның Кали қаласында тоғызқұмалақтан халықаралық турнир өтті. Жарысқа Колумбия, Бразилия, Мексика, Эквадор, Аргентина, Чили, Гватемала, Панама, Венесуэла, Қазақстан елдерінен 50 жуық спортшы қатысты.\n' +
        'Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізді. Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына  ҚР Туризм және спорт министрлігі, Sport Qory  демеушілік қолдау көрсетті. Жарыстың бас демеушісі - Kazpetrol Group.\n',
      description: "Нәтижесінде рапид түрі бойынша, ерлер:\n" +
        "1 орын - Әуелбай Ерсұлтан (Қазақстан);\n" +
        "2 орын - Fajardo Chica Oscar Alvaro (Колумбия);\n" +
        "3 орын - Бостандықов Бексұлтан (Қазақстан);\n" +
        "3 орын - Gutierrez Roa Rommel Augusto (Эквадор).\n" +
        "Әйелдер арасында,\n" +
        "1 орын - Далиева Әсел (Қазақстан);\n" +
        "2 орын - Есіркеп Құндыз;\n" +
        "3 орын - Gomez Maria Sophia (Колумбия);\n" +
        "3 орын - Arteaga Quintana Andrea Paulina ( Эквадор).\n" +
        "Классика бойынша:\n" +
        "1 орын - Зкрияев Биғали (Қазақстан);\n" +
        "2 орын - Қожанәсіп Аңсаған (Қазақстан);\n" +
        "3 орын - Қайдаров Азамат (Қазақстан);\n" +
        "3 орын - Маханбетамин Ұлдана (Қазақстан).\n" +
        "Латын Америкасы бойынша:\n" +
        "1 орын - Acuna Ricardo Alberto ( Аргентина);\n" +
        "2 орын - Fajardo Chica Oscar Alvaro (Колумбия);\n" +
        "3 орын - Chilito Daniel Alejandro (Колумбия).\n"
    },
    {
      id: 65,
      image: 'assets/imgs/mongolia/2.jpeg',
      published: new Date('2024-11-19'),
      title: '2024 жылғы 10-19 қараша аралығында Улан-Батор (Моңғолия) қаласында тоғызқұмалақтан 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті. Оған Қазақстан, Моңғолия, Ресей, Өзбекстаннан елдерінен 31 спортшы қатысты. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы мен Моңғолия Тоғызқұмалақ Федерациясы бірлесіп өткізді. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетті.',
      description: "Нәтижесінде классика бойынша, 13 жасқа дейінгі ұлдар:\n" +
        "1 орын Ернар Ертай (KAZ)\n" +
        "2 орын Сагумбаев Карим (KAZ)\n" +
        "3 орын Кошкарбаев Мухаммедали (UZB)\n" +
        "3 орын Берикбол Бейбарыс (MNG)\n" +
        "13 жасқа дейінгі қыздар:\n" +
        "1 орын Алпыскызы Жайна (KAZ)\n" +
        "2 орын Артық Назым (KAZ)\n" +
        "3 орын Муратхан Нурдана(MNG)\n" +
        "3 орын Тортулова Риана(RUS)\n" +
        "15 жасқа дейінгі ұлдар:\n" +
        "1 орын Арғынғазин Дінмұхаммед (KAZ)\n" +
        "2 орын Тоқтасын Нұрхан (KAZ)\n" +
        "3 орын Салауат Абділ (MNG)\n" +
        "3 орын Солтанов Нуриддин(RUS)\n" +
        "15 жасқа дейінгі қыздар:\n" +
        "1 орын Шамшиева Жанель (KAZ)\n" +
        "2 орын Ұстазхан Нұрсая (KAZ)\n" +
        "3 орын Ерлан Айгерим (MNG)\n" +
        "3 орын Ташкент Сержан (MNG)\n" +
        "17 дейінгі ұлдар:\n" +
        "1 орын Ахметов Надир (KAZ)\n" +
        "2 орын Сайлаубек Ерасыл (KAZ)\n" +
        "3 орын Солтанов Нурралиф(RUS)\n" +
        "3 орын Турсынбаев Азизбек (UZB)\n" +
        "17 жасқа дейінгі қыздар:\n" +
        "1 орын Жандарбек Мөлдір (KAZ)\n" +
        "2 орын Молдабек Айдана (KAZ)\n" +
        "3 орын Муратхан Нуржулдыз(MNG)\n" +
        "3 орын Успанова Гульмира (UZB)\n" +
        "Рапид бойынша, 13 жасқа дейінгі ұлдар:\n" +
        "1 орын Ернар Ертай (KAZ)\n" +
        "2 орын Сагумбаев Карим (KAZ)\n" +
        "3 орын Берикбол Бейбарыс (MNG)\n" +
        "3 орын Өзбек Мухамед (UZB)\n" +
        "13 жасқа дейінгі қыздар:\n" +
        "1 орын Артық Назым (KAZ)\n" +
        "2 орын Алпысқызы Жайна (KAZ)\n" +
        "3 орын Муратхан Нурдана (MNG)\n" +
        "3 орын Туртулова Риана (RUS)\n" +
        "15 жасқа дейінгі ұлдар:\n" +
        "1 орын Тоқтасын Нұрхан (KAZ)\n" +
        "2 орын Салауат Абділ (MNG)\n" +
        "3 орын Арғынғазин Дінмұхаммед (KAZ)\n" +
        "3 орын Алтынбек Қолдаған (MNG)\n" +
        "15 жасқа дейінгі қыздар:\n" +
        "1 орын Ұстазхан Нұрсая (KAZ)\n" +
        "2 орын Шамшиева Жанель (KAZ)\n" +
        "3 орын Ерлан Айгерім (MNG)\n" +
        "3 орын Ташкент Сержан (MNG)\n" +
        "17 дейінгі ұлдар: \n" +
        "1 орын Ахметов Надир (KAZ)\n" +
        "2 орын Сайлаубек Ерасыл (KAZ)\n" +
        "3 орын Ерген Ағарыс (MNG)\n" +
        "3 орын Тұрсынбаев Азизбек (UZB)\n" +
        "17 жасқа дейінгі қыздар:\n" +
        "1 орын Молдабек Айдана (KAZ)\n" +
        "2 орын Жандарбек Мөлдір (KAZ)\n" +
        "3 орын Мұратхан Нуржулдыз (MNG)\n" +
        "3 орын Асемхан Сәндігүл(MNG).\n"
    },
    {
      id: 2,
      image: 'assets/imgs/mongolia/3.jpeg',
      published: new Date('2024-11-19'),
      title: '2025 жылғы 16-26 мамыр аралығында \n' +
        'Өлгий (Моңғолия) қаласында тоғызқұмалақтан 11, 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті.\n' +
        'Оған Ресей Федерациясы, Өзбекістан, Моңғолия, Қазақстан елдерінен спортшылар қатысты.\n' +
        'Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізді.\n' +
        'Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Самұрық-Қазына қоры мен Спорты қолдау қоры демеушілік қолдау көрсетті.',
      description: 'Нәтижесінде классика бойынша, 11 жасқа дейінгі ұлдар:\n'+
        '🥇Mukhammad Amangeldi (Қазақстан);\n'+
        '🥈Diyar Baktybek (Қазақстан);\n'+
        '🥉Zhantileu Oryntai (Моңғолия);\n'+
        '🥉Askarbek Yerbol (Моңғолия).\n'+
        '11 жасқа дейінгі қыздар:\n'+
        '🥇Arna Kuvatova (Қазақстан);\n'+
        '🥈Dana Nazhkey (Қазақстан);\n'+
        '🥉Nazel Akhmetkalieva (Ресей Федерациясы);\n'+
        '🥉Amina Agarys (Моңғолия)\n'+
        '13 жасқа дейінгі ұлдар:\n'+
        '🥇Aisultan Kairidenov (Қазақстан);\n'+
        '🥈Zhassyn Avilkhan (Қазақстан);\n'+
        '🥉Zhandos Nurgylan (Моңғолия);\n'+
        '🥉Nardaulet Ornykpay (Ресей Федерациясы).\n'+
        '13 жасқа дейінгі қыздар:\n'+
        '🥇Aizhan Temirbayeva (Қазақстан);\n'+
        '🥈Saidulla Nugaim (Қазақстан); \n'+
        '🥉Riana Tartulova (Ресей Федерациясы);\n'+
        '🥉Muslima Koshkarbayeva  (Өзбекістан).\n'+
        '\n'+
        '15 жасқа дейінгі ұлдар:\n'+
        '🥇Arnat Kairidenov (Қазақстан);\n'+
        '🥈Ayan Kuanysh (Қазақстан);\n'+
        '🥉Alyar Kassenov (Ресей Федерациясы);\n'+
        '🥉Zhanali Samarkhanov (Ресей Федерациясы).\n'+
        '15 жасқа дейінгі қыздар:\n'+
        '🥇Azelya Abdiraly (Қазақстан);\n'+
        '🥈Raikhan Orazbayeva (Қазақстан);\n'+
        '🥉Aigerim Yerlan (Моңғолия);\n'+
        '🥉Gulmira Uspanova (Өзбекістан).\n'+
        '\n'+
        '\n'+
        '\n'+
        '17 жасқа дейінгі ұлдар:\n'+
        '🥇Dias Tastimov (Қазақстан);\n'+
        '🥈Iliyas Mukhametzhan (Қазақстан);\n'+
        '🥉Malik Assylbek (Моңғолия);\n'+
        '🥉Abdil Salauat (Моңғолия).\n'+
        '17 жасқа дейінгі қыздар:\n'+
        '🥇Gulbakhar Saidulla (Қазақстан);\n'+
        '🥈Aziza Kulbayeva (Қазақстан);\n'+
        '🥉Amira Mataeva (Ресей Федерациясы);\n'+
        '🥉Akbota Bagdaulet (Моңғолия).\n'+
        '\n'+
        '\n'+
        'Нәтижесінде рапид бойынша, 11 жасқа дейінгі ұлдар:\n'+
        '🥇Mukhammad Amangeldi (Қазақстан);\n'+
        '🥈Diyar Baktybek (Қазақстан);\n'+
        '🥉Nurali Sailau (Моңғолия);\n'+
        '🥉Yerasyl Begzhan (Моңғолия).\n'+
        '11 жасқа дейінгі қыздар:\n'+
        '🥇Dana Nazhkey (Қазақстан);\n'+
        '🥈Arna Kuvatova (Қазақстан);\n'+
        '🥉Zhanbota Amman (Моңғолия);\n'+
        '🥉Amina Agarys (Моңғолия).\n'+
        '\n'+
        '13 жасқа дейінгі ұлдар:\n'+
        '🥇Aisultan Kairidenov (Қазақстан);\n'+
        '🥈Zhassyn Avilkhan (Қазақстан);\n'+
        '🥉Aidyn Khabyl (Моңғолия);\n'+
        '🥉Ulan Nurbol (Ресей Федерациясы).\n'+
        '13 жас қыздар арасында:\n'+
        '🥇Aizhan Temirbayeva (Қазақстан);\n'+
        '🥈Saidulla Nugaim (Қазақстан);\n'+
        '🥉Medina Akhan (Моңғолия);\n'+
        '🥉Dana Shynuar (Ресей Федерациясы).\n'+
        '\n'+
        '15 жасқа дейінгі ұлдар:\n'+
        '🥇Arnat Kairidenov (Қазақстан);\n'+
        '🥈Ayan Kuanysh (Қазақстан);\n'+
        '🥉Ibrakhim Yermurat (Моңғолия);\n'+
        '🥉Nariman Nurbol (Ресей Федерациясы).\n'+
        '15 жасқа дейінгі қыздар:\n'+
        '🥇Azelya Abdiraly (Қазақстан);\n'+
        '🥈Raikhan Orazbayeva (Қазақстан);\n'+
        '🥉Aigerim Yerlan (Моңғолия);\n'+
        '🥉Gulmira Uspanova (Өзбекістан). \n'+
        '\n'+
        '\n'+
        '17 жасқа дейінгі ұлдар:\n'+
        '🥇Iliyas Mukhametzhan (Қазақстан);\n'+
        '🥈Dias Tastimov (Қазақстан);\n'+
        '🥉Nurdaulet Khadyskhan (Моңғолия);\n'+
        '🥉Daurenbek Shapagat (Моңғолия).\n'+
        '\n'+
        '17 жасқа дейінгі қыздар:\n'+
        '🥇Gulbakhar Saidulla (Қазақстан);\n'+
        '🥈Aziza Kulbayeva (Қазақстан);\n'+
        '🥉Nurzhuldyz Muratkhan (Моңғолия);\n'+
        '🥉Sezhan Tashken (Моңғолия).'
    },
    {
      id: 1,
      image: 'assets/imgs/korea/1.jpeg',
      published: new Date('2024-11-19'),
      title: '2025 жылғы 24-30 маусым аралығында Оңтүстік Кореяның Сеул қаласында тоғызқұмалақтан халықаралық турнир өтуде.\n' +
        'Жарысқа ерлер мен әйелдер арасында Оңтүстік Корея, Моңғолия, Үндістан және Қазақстан елдерінің спортшылары қатысуда.\n' +
        'Тоғызқұмалақтан ҚР Ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Самұрық-Қазына қоры мен Спортты қолдау қоры демеушілік қолдау көрсетуде.',
      description: ''
    },
    {
      id: 3,
      image: 'assets/imgs/korea/2.jpeg',
      published: new Date('2024-11-19'),
      title: '2025 жылғы 24-30 маусым аралығында Оңтүстік Кореяның Сеул қаласында тоғызқұмалақтан халықаралық турнир өтті. Жарысқа Оңтүстік Корея, Қазақстан, Моңғолия және Үндістан елдерінің спортшылары қатысты.\n' +
        'Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Самұрық-Қазына қоры мен Спортты қолдау қоры демеушілік қолдау көрсетті.',
      description: 'Турнир нәтижесінде:\n' +
        'Ерлер арасында,\n' +
        '1 орын - Ринат Керейбаев (Қазақстан);\n' +
        '2 орын - Дархан Ануарбеков (Қазақстан);\n' +
        '3 орын - Yerbol Doldai (Моңғолия);\n' +
        '3 орын - Amandakh Jaltai (Монголия).\n' +
        'Әйелдер арасында,\n' +
        '1 орын - Гүлнара Базаралиева (Қазақстан);\n' +
        '2 орын - Аяна Исахан (Қазақстан);\n' +
        '3 орын - Sanghee Oh (Оңтүстік Корея);\n' +
        '3 орын — Sehee Yang (Оңтүстік Корея) иеленді.'
    },
    {
      id: 9,
      image: 'assets/imgs/czhecia/2.jpeg',
      published: new Date('2024-11-19'),
      title: '2024 жылғы 6-16 желтоқсан аралығында Прага (Чехия) қаласында тоғызқұмалақтан 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті. Оған Чехия, Испания, Венгрия, Польша, Қазақстан елдерінен спортшылар қатысты. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізді. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетті.',
      description: 'Нәтижесінде рапид бойынша, 13 жасқа дейінгі ұлдар:\n' +
        '1 орын Galymzhan Temirlan (Қазақстан);\n' +
        '2 орын Serikbay Nurislam (Қазақстан);\n' +
        '3 орын Amigo Maxim (Испания).\n' +
        '13 жасқа дейінгі қыздар:\n' +
        '1 орын Saidulla Nugaim (Қазақстан);\n' +
        '2 орын Kengesbekova Yerkezhan (Қазақстан);\n' +
        '3 орын Dvorakova Tereza (Чехия).\n' +
        '15 жасқа дейінгі ұлдар:\n' +
        '1 орын Khalel Azamat (Қазақстан);\n' +
        '2 орын Les Zauytbek (Қазақстан);\n' +
        '3 орын Biro Oszkar (Венгрия);\n' +
        '3 орын Biro Mark (Венгрия).\n' +
        '15 жасқа дейінгі қыздар:\n' +
        '1 орын Yesmukan Albina (Қазақстан);\n' +
        '2 орын Kuatzhankyzy Nazira (Қазақстан);\n' +
        '3 орын Novakova Jana (Чехия).\n' +
        '17 дейінгі ұлдар:\n' +
        '1 орын Bekmakhan Adilet (Қазақстан);\n' +
        '2 орын Makhmutzhan Azimkhan (Қазақстан);\n' +
        '3 орын Visnyei Laszlo (Венгрия);\n' +
        '3 орын Vaclav Vokurka (Чехия).\n' +
        '17 жасқа дейінгі қыздар:\n' +
        '1 орын Belitskaya Viktotiya (Қазақстан);\n' +
        '2 орын Salmen Aruzhan (Қазақстан);\n' +
        '3 орын Hetfleischova Elen (Чехия);\n' +
        '3 орын Amigo Alexandra (Испания).\n' +
        'Классика бойынша, 13 жасқа дейінгі ұлдар:\n' +
        '1 орын Serikbay Nurislam (Қазақстан);\n' +
        '2 орын Galymzhan Temirlan (Қазақстан);\n' +
        '3 орын Robakowski Eryk (Польша);\n' +
        '3 орын Robakowski Kamil (Польша).\n' +
        '13 жасқа дейінгі қыздар:\n' +
        '1 орын Saidulla Nugaim (Қазақстан);\n' +
        '2 орын Kengesbekova Yerkezhan (Қазақстан);\n' +
        '3 орын Dvorakova Tereza (Чехия).\n' +
        '15 жасқа дейінгі ұлдар:\n' +
        '1 орын Les Zauytbek (Қазақстан);\n' +
        '2 орын Armatuly Nurali (Қазақстан);\n' +
        '3 орын Khalel Azamat (Қазақстан);\n' +
        '3 орын Robakowski Eldar Daniel (Польша).\n' +
        '15 жасқа дейінгі қыздар:\n' +
        '1 орын Yesmukan Albina (Қазақстан);\n' +
        '2 орын Kuatzhankyzy Nazira (Қазақстан);\n' +
        '3 орын Novakova Jana (Чехия).\n' +
        '17 дейінгі ұлдар:\n' +
        '1 орын Makhmutzhan Azimkhan (Қазақстан);\n' +
        '2 орын Bekmakhan Adilet (Қазақстан);\n' +
        '3 орын Kotin Vladimir (Чехия).\n' +
        '17 жасқа дейінгі қыздар:\n' +
        '1 орын Salmen Aruzhan (Қазақстан);\n' +
        '2 орын Begaliyeva Akbota (Қазақстан);\n' +
        '3 орын Belitskaya Viktotiya (Қазақстан).\n' +
        '\n'
    },
    {
      id: 41,
      image: 'assets/imgs/kyrgyzstan/1.jpeg',
      published: new Date('2024-11-19'),
      title: '2024 жылғы 5-12 желтоқсан аралығында Қырғызстан Республикасының Бішкек қаласында тоғызқұмалақтан Ч.Айтматовты еске алуға арналған халықаралық турнир өтуде. Жарысқа Қазақстан, Қырғызстан, Өзбекстан және Ресей елдерінен 235 спортшы қатысуда. Жарыс ардагерлер, ерлер мен әйелдер, U-15 ұлдар мен қыздар арасында өтуде.\n' +
        'Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына Қазақстан Республикасының Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде.\n',
      description: ''
    },
    {
      id: 51,
      image: 'assets/imgs/columbia/1.jpeg',
      published: new Date('2024-11-19'),
      title: '2024 жылғы 22-30 қараша аралығында Колумбияның Кали қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа ерлер мен әйелдер арасында Колумбия, Бразилия, Мексика, Эквадор, Аргентина, Чили, Гватемала, Панама, Венесуэла, Германия Қазақстан елдерінің спортшылары қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізуде. \n' +
        'Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде. Жарыстың бас демеушісі - Kazpetrol Group.\n',
      description: ''
    },
    {
      id: 66,
      image: 'assets/imgs/mongolia/1.jpeg',
      published: new Date('2024-11-19'),
      title: '2024 жылғы 10-19 қараша аралығында Моңғолияның Улан-Батор қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа 13, 15, 17 жасқа дейінгі Моңғолия, Қазақстан, Ресей, Өзбекстан елдерінің спортшылары (офлайн/онлайн) қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы мен Моңғолия Тоғызқұмалақ Федерациясы бірлесіп өткізуде. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory қолдау көрсетуде.',
      description: ''
    }
  ];

  constructor(private router: ActivatedRoute, private route: Router, private http: HttpService, public translate: TranslateService,
              private meta: Meta) {
  }

  ngOnInit(): void {
    this.getNewsItem();
  }

  // Main section
  getNewsItem() {
    // let type = this.router.snapshot.paramMap.get('type');
    const newsId = +this.router.snapshot.paramMap.get('id'); // cast to number
    this.newsElement = this.newsElements.find(item => item.id === newsId);

    // if (type == 'country') {
    //   this.getNewsItemByCountry(newsId);
    //   this.getNewsByCountry();
    // } else {
    //   this.getNewsItemByRegion(newsId);
    //   this.getNewsByRegion();
    // }
  }

  getNewsItemByCountry(newsId) {
    this.http.getNewsByIdCountryService(newsId).subscribe((data: any) => {
      // this.newsElement = data;
      // this.newsElement.type = 'country'
    });
  }

  getNewsItemByRegion(newsId) {
    this.http.getNewsByIdService(newsId).subscribe((data: any) => {
      // this.newsElement = data;
      // this.newsElement.type = 'city'
    });
  }


  getNewsByRegion() {
    this.http.getKazNewsWithoutContent(sessionStorage.getItem('lang')).subscribe(data => {
      data = data.slice(0,3)
      this.allNews = data;
      this.allNews.forEach(news => {news.type = 'city'})
      // this.updateMetaTag();
    });
  }

  getNewsByCountry() {
    this.http.getWorldNewsWithoutContent(sessionStorage.getItem('lang')).subscribe(data => {
      data = data.slice(0,3)
      this.allNews = data;
      this.allNews.forEach(news => {news.type = 'country'})
      // this.updateMetaTag();
    });
  }

  redirectNewsPage(item) {
    this.route.navigate(['/news', item.type, item.id]).then(() =>
      location.reload()
    );
  }

  ngAfterContentChecked(): void {
    this.change();
    // this.updateMetaTag();
  }


  // updateMetaTag() {
  //   this.meta.updateTag({ property: 'og:title', content: this.newsElement.title })
  //   this.meta.updateTag({ property: 'og:description', content: this.newsElement.title })
  //   this.meta.updateTag({ property: 'og:image', content: this.newsElement.image })
  //   this.meta.updateTag( { property: 'og:url', content: 'https://9qq.org/#/news/' + this.newsElement.type + '/' + this.newsElement.id });
  // }

  change() {
    const heyElement = document.getElementById('news-content');
    if (heyElement) {
      const imgElements = heyElement.getElementsByTagName('img');
      if (imgElements != null) {
        for (let i = 0; i < imgElements.length; i++) {
          if (imgElements[i] != null) {
            imgElements[i].style.maxWidth = '700px';
            imgElements[i].style.maxHeight = '100%';
          }
        }
      }
    }
  }
}
